
import React from 'react'
import EstimatedCard from './EstimatedCard'
import { useNavigate } from 'react-router-dom'
import { useAuthState } from '../../../../../Helper/Context';


export default function EstimatedCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const navigate = useNavigate()
    const EstimateAmountNavigate = (name, screenFlag) => {

        if (name === "Estimated Amount (RS)") {
            navigate(`/roadworkestimated?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Ward Wise Work") {
            navigate(`/roadworkprogresscompleted?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }
    return (

        <div className='row road_work'>
            <div className="col-lg-4 col-md-6 col-12" >
                <EstimatedCard
                    heading='Estimated Amount (RS)'
                    count={Countdata.ESTIMATED_AMOUNT ? Countdata.ESTIMATED_AMOUNT : '0'}
                    imgPath='./assets/img/money.png'
                    cardName='estimate_img'
                    // navLink='/roadworkestimated'
                    countText='green_color'
                    EstimateAmountNavigate={EstimateAmountNavigate}
                />
            </div>
            <div className="col-lg-4 col-md-6 mt-2 mt-lg-0" >
                <EstimatedCard
                    heading='Ward Wise Work'
                    count={Countdata.WorkProgress_CompletedTotalCount ? Countdata.WorkProgress_CompletedTotalCount : '0'}
                    imgPath='./assets/img/working.png'
                    cardName='estimate_img'
                    // navLink='/roadworkprogresscompleted'
                    countText='green_color'
                    EstimateAmountNavigate={EstimateAmountNavigate}
                />
            </div>
        </div>

    )
}






